import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Constraint,
  Event,
  Id,
  Identifiable,
  List,
  Milestone,
  Project,
  Task,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  constraint:
    | (Identifiable<Constraint> & {
        target:
          | Identifiable<Task>
          | Identifiable<List>
          | Identifiable<Event>
          | Identifiable<Milestone>;
        origin:
          | Identifiable<Task>
          | Identifiable<List>
          | Identifiable<Event>
          | Identifiable<Milestone>;
        project: Identifiable<Project>;
      })
    | undefined;
  retrieveConstraint(
    request: Boundaries["retrieveConstraint"]["request"],
  ): void;
}

function useRetrieveConstraint(constraintId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveConstraintRequestPending(constraintId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveConstraintRequestSuccess(constraintId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveConstraintRequestFailure(constraintId),
    ),
    constraint: useSelector(() => selector.getConstraint(constraintId)),
    retrieveConstraint: core.retrieveConstraint,
  };
}

export { useRetrieveConstraint };
